import { Button, Group } from "@mantine/core";

import { toDateInputValue } from "../../utils/dates";

interface ExpirationQuickSetProps {
	disabled?: boolean;
	onSelect: (date: string) => void;
}

function ExpirationQuickSet({ disabled, onSelect }: ExpirationQuickSetProps) {
	const selectOffset = (days: number) => {
		const target = new Date();
		target.setDate(target.getDate() + days);
		onSelect(toDateInputValue(target));
	};

	return (
		<Group gap="xs">
			<label style={{ fontSize: "14px", fontWeight: 500 }}>Quick set:</label>
			<Button
				variant="subtle"
				size="xs"
				disabled={disabled}
				onClick={() => selectOffset(365)}>
				1 Year
			</Button>
			<Button
				variant="subtle"
				size="xs"
				disabled={disabled}
				onClick={() => selectOffset(Math.round(365 / 2))}>
				6 Months
			</Button>
			<Button
				variant="subtle"
				size="xs"
				disabled={disabled}
				onClick={() => selectOffset(90)}>
				3 Months
			</Button>
		</Group>
	);
}

export default ExpirationQuickSet;
